const permissions = {
  viewHubs: 'HB001',
  manageHubAssignment: 'HB002'
};

export default permissions;
